import _ from 'lodash-es'
import React from 'react'

/**
 * 获取权限函数
 * @param defaultValue
 */
export const getAuth = (defaultValue: any = {}) => {
  const stateStr = localStorage.getItem('buttonAuth')
  return stateStr ? JSON.parse(stateStr) : defaultValue
}

/**
 * 权限高级组件
 * @param WrappedComponent
 * @param bool
 */
export function iiHOC(WrappedComponent?: React.ReactNode | any, bool?: boolean) {
  const roleCodesAuthority = getAuth(null) || (window as any).roleCodesAuthority

  if (typeof bool == 'boolean' && bool) {
    //表头数组权限
    if (!roleCodesAuthority) return WrappedComponent
    _.remove(WrappedComponent, function (child) {
      if (!child) return false
      return child['datareskey'] && !roleCodesAuthority[child['datareskey']]
    })
    return WrappedComponent
  }
  if (typeof WrappedComponent == 'object') {
    // console.log('***********************')

    WrappedComponent = all(WrappedComponent)
    return WrappedComponent
  }

  let ownForm = null

  /* function form (elementsTree) {
                                                  if (!ownForm) return;
                                                  if (elementsTree.props.fromId) ownForm.getFieldDecorator(elementsTree.props.fromId, {rules: []})(<Input />);
                                                } */
  function all(elementsTree) {
    // console.log(elementsTree, roleCodesAuthority);
    if (!elementsTree) return
    if (!roleCodesAuthority && elementsTree.props && elementsTree.props['datareskey']) return
    if (!isNaN(elementsTree.length)) {
      //数组
      const newArray = [...elementsTree]

      _.remove(newArray, function (child) {
        if (child) {
          return (
            child.props &&
            child.props['datareskey'] &&
            !roleCodesAuthority[child.props['datareskey']]
          )
        }
      })
      for (let i = 0; i < newArray.length; i++) {
        if (typeof newArray[i] == 'object') newArray[i] = all(newArray[i])
      }
      return newArray
    }
    let newElementsTree = Object.assign({}, elementsTree)
    if (!newElementsTree.props || !roleCodesAuthority) return elementsTree

    if (newElementsTree.props.prefixCls && newElementsTree.props.prefixCls == 'ant-select')
      return newElementsTree
    if (newElementsTree.props.ownForm) ownForm = newElementsTree.props.ownForm

    // console.log('iiHOC', newElementsTree);
    if (
      newElementsTree.props['datareskey'] &&
      !roleCodesAuthority[newElementsTree.props['datareskey']]
    ) {
      newElementsTree = null
    }
    if (newElementsTree) {
      if (newElementsTree.props.children && typeof newElementsTree.props.children == 'object') {
        const object = newElementsTree.props.children
        if (!isNaN(object.length)) {
          //数组
          const newArray = [...object]
          _.remove(newArray, function (child) {
            return (
              child &&
              child.props &&
              child.props['datareskey'] &&
              !roleCodesAuthority[child.props['datareskey']]
            )
          })
          for (let i = 0; i < newArray.length; i++) {
            if (typeof newArray[i] == 'object') newArray[i] = all(newArray[i])
          }
          newElementsTree.props = Object.assign({}, newElementsTree.props, { children: newArray })
        } else {
          const newObject = Object.assign({}, object)
          if (
            newObject.props &&
            newObject.props['datareskey'] &&
            !roleCodesAuthority[newObject.props['datareskey']]
          ) {
            newElementsTree.props = {}
          } else {
            newElementsTree.props = Object.assign({}, newElementsTree.props, {
              children: all(newObject),
            })
          }
        }
        // typeof (elementsTree.props.children) == 'string'
      } else if (elementsTree.props) {
        const newObject = Object.assign({}, elementsTree)
        if (newObject.props['datareskey'] && !roleCodesAuthority[newObject.props['datareskey']]) {
          newElementsTree = null
        }
      }
    }

    return newElementsTree
  }

  return class Enhancer extends WrappedComponent {
    render() {
      if (!roleCodesAuthority) return null
      let elementsTree = super.render()
      // console.log('-------------------------------')
      ownForm = ''
      elementsTree = all(elementsTree)
      const newProps = {}
      const props = Object.assign({}, elementsTree.props, newProps)
      const newElementsTree = React.cloneElement(elementsTree, props, elementsTree.props.children)
      return newElementsTree
    }
  }
}

/**
 * 权限hook
 */
export const useButtonAuth = () => {
  const storeAuth = getAuth()
  return [storeAuth || {}]
}
// SListTabs 根据角色权限获取 items
export const getAuthTabs=(arr)=>{
  const auths=getAuth()
  const authArr:any[]=[]
  arr.map(item=>{
      if(auths[item.auth]){
          authArr.push(item)
      }
  })
  return authArr
}